import { FILE_REQUEST_ACTION_TYPE } from '../actions';

const initialState = {
  type: null,
  fileEncodedData: null,
  errorMessage: null,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FILE_REQUEST_ACTION_TYPE.GET_FILE_REQUEST_STATUS: {
      const { type, Content: fileEncodedData, errorMessage } = payload;

      return {
        ...state,
        status: type,
        errorMessage,
        fileEncodedData,
      };
    }

    default:
      return state;
  }
};

export default reducer;
